/**
 * Stable CSS class names for E2E — RuleServiceV2 tenant/domain selection.
 */
export const TS = {
    root: 'tenant-select',
    imageRow: 'tenant-select__image-row',
    image: 'tenant-select__image',

    formRow: 'tenant-select__form-row',
    domainControl: 'tenant-select-input__domain-control',
    domainLabel: 'tenant-select-input__domain-label',
    domainSelect: 'tenant-select-input__domain-select',
    domainOption: 'tenant-select-input__domain-option',

    globalRuleControl: 'tenant-select-input__global-rule-control',
    globalRuleCheckbox: 'tenant-select-input__global-rule-checkbox',

    actionsRow: 'tenant-select__actions-row',
    searchButton: 'tenant-select-input--button-search',
} as const;

export const tsCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

